import React, { useEffect } from 'react';
import { OneColumnLayout, TwoColumnLayout } from '../layouts';
import { useViewport } from '../../hooks/useViewport';
import { MobileLoadingGrid } from './components/MobileLoadingGrid/MobileLoadingGrid';
import { LoadingGrid } from './components/LoadingGrid/LoadingGrid';
import { SideContent } from './components/LoadingGrid/SideContent';
import { PRODUCTS_BY_CATEGORY } from '../../consts';
import { useCreateSiteFromTemplate, useSetupModalystProducts } from '../../features/templateSelection/api';

interface LoadingGridWrapperProps {
  category: string;
}

export function LoadingGridWrapper({ category }: LoadingGridWrapperProps) {
  const { isMobile } = useViewport();
  const { mutateAsync: createSite } = useCreateSiteFromTemplate();
  const { mutateAsync: setupProducts } = useSetupModalystProducts();
  const products = PRODUCTS_BY_CATEGORY[category];

  useEffect(() => {
    const initializeSite = async () => {
      if (!category) {
        return;
      }

      try {
        const metaSiteId = await createSite(category);
        const productIds = products.map((product) => product.id);
        await setupProducts({ metaSiteId, productList: productIds });
      } catch (error) {
        console.error('Failed to create site:', error);
      }
    };

    initializeSite();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [category]);

  if (isMobile) {
    return <OneColumnLayout content={<MobileLoadingGrid products={products} />} />;
  }

  return (
    <TwoColumnLayout
      mainContent={<LoadingGrid products={products} />}
      sideContent={<SideContent products={products} />}
      mainContentSpan={6}
    />
  );
}
